export default __webpack_public_path__ + "static/media/gallery_07.90bf7380.jpg";